export default __webpack_public_path__ + "static/media/slide2.3e156177.jpg";